module.exports = __webpack_public_path__ + "img/chicken.be5030ca.webp";